
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7930"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7930"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hcit7", function(module, exports) {

$parcel$export(module.exports, "register", () => $c851e220a1a47cf5$export$6503ec6e8aabbaf, (v) => $c851e220a1a47cf5$export$6503ec6e8aabbaf = v);
var $c851e220a1a47cf5$export$6503ec6e8aabbaf;
var $c851e220a1a47cf5$export$f7ad0328861e2f03;
"use strict";
var $c851e220a1a47cf5$var$mapping = new Map();
function $c851e220a1a47cf5$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$c851e220a1a47cf5$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $c851e220a1a47cf5$var$resolve(id) {
    var resolved = $c851e220a1a47cf5$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$c851e220a1a47cf5$export$6503ec6e8aabbaf = $c851e220a1a47cf5$var$register;
$c851e220a1a47cf5$export$f7ad0328861e2f03 = $c851e220a1a47cf5$var$resolve;

});

var $282f7d54ad8dff7e$exports = {};

(parcelRequire("hcit7")).register(new URL("", import.meta.url).toString(), JSON.parse('["ekJmX","index.7650894d.js","7VSTx","stars.4647cac0.jpg","gyacy","sun.b2f09a78.jpg","fMmBl","mercury.829e3aac.jpg","jRdqc","venus.abf2a45d.jpg","2phzL","earth.bf6d9bee.jpg","eEFib","mars.b63e3f37.jpg","gegOR","jupiter.f0dc6d3f.jpg","hDTBU","saturn.8238dc23.jpg","bZu2a","saturn_ring.c7f83c13.png","lbrlK","uranus.0652fb86.jpg","1U9ba","uranus_ring.57ff41dc.png","d3O16","neptune.52011b3d.jpg","1PDkU","pluto.b1a104be.jpg","1pkrP","milky way galaxy.b10294b5.jpeg","iZbGm","galaxy1.e73cf1a7.jpg","i8AeE","galaxy2.5d7d68e1.jpg","6pkNi","galaxy3.ee071803.jpg","iqXWR","galaxy4.07003be7.jpg","9uUYK","galaxy5.ccdbc6d8.jpg","4I7rQ","galaxy6.37bf939c.jpg","39X2N","galaxy7.fefd244d.jpg","a31NL","galaxy8.dd618fbc.jpg","d5zLx","galaxy9.ee455eab.jpg"]'));


//# sourceMappingURL=index.runtime.d9c4a145.js.map
